<template>
  <div class="text-wrap">
    <label class="label input__label" v-if="useLabel" :for="this.id">{{ this.label }}</label>
  	<div :class="setWrapperClass">
  		<input v-if="this.type !== 'textarea'"
         :id="this.id"
  		   :class="setClass"
  		   :type="setType"
  			 :value="setValue"
  	     :placeholder="placeholder"
         :data-type="setDataType"
  			 @change="saveValue"
         :disabled="this.disabled">
      <textarea v-else
         :id="this.id"
         :class="setClass"
         :type="setType"
         :value="setValue"
         :placeholder="placeholder"
         :data-type="setDataType"
         @change="saveValue"
         :disabled="this.disabled"></textarea>       
  	</div>
  </div>
</template>

<script>

export default {

  /**
   * METHODS
   * -------
   * 
   * These are the methods that are available to the 
   * component.
   */
   
  methods : {

  	saveValue(e) {

      var val  = e.target.value,
          type = e.srcElement.dataset.type,
          d = true;

      // Check for types
      if (type === 'percentage') {

        val /= 100;
        val = val.toFixed(4);

      }

      // Check for context
  		if (this.context) {

  			if ( this.context === 'repeater' ) {

					var vars = this.$parent.$parent.$data.subpanel;
  				
  				this.$store.dispatch('saveCell', {
            field:   vars.field,
						row:     this.row,
						index:   this.index,
            key:     this.k,
            type:    this.type,            
            value:   val,
            setting: this.setting,
		  		});

          d = false;

  			}

  		}

      if ( this.type === 'number' ||
           this.type === 'currency' || 
           this.type === 'percentage' ) {

        val = Number(val);

      }

      if ( this.setting && 
           this.context !== 'repeater' && 
           this.context !== 'modal' ) {

        this.$store.dispatch('saveSetting', {
          field: this.field,
          value: val,
        });

      }

      else if ( this.context === 'modal' ) {

        this.$store.dispatch('savePrintOption', {
          field: this.field,
          value: val,
        });

      }

  		else if (d) {

        this.$store.dispatch('saveField', {
          field: this.field,
          value: val,
        });

  		}

  	}

  },


  /**
   * COMPUTED
   * --------
   * 
   * These functions are used to return computed values, which
   * can be bound to certain portions of the component.
   */  

  computed: {

  	setValue() {

      var val  = '',
          type = 'text'; 

      if ( this.field !== undefined ) { 

        if ( this.field.substr(0 , 5) === 'calc.' ) {

          var f = this.field.substr(5),
              g = this.$store.getters[this.field.substr(5)];

          if ( g !== undefined ) {

            val = g;

          }

          type = this.type;

        }

        else if ( this.setting === 'true' ) {
          
          val  = this.$store.getters.getSettingData({ field: this.field });          

        }

        else if ( this.field   !== undefined && 
                  this.context !== 'repeater' &&
                  this.context !== 'modal' ) {

          val  = this.$store.getters.getFieldData({ field: this.field });
          type = this.type;

          if ( this.value !== undefined ) {

            val  = this.value;

          }

        }

        else if ( this.context === 'modal' ) {

          var modal = this.$store.getters.modalVars,
              val = false;

          if ( modal.component === 'printForm') {

            var print = this.$store.getters.getPrintOptions;

            val = print[this.field];

          }

        }                

      }

      else if ( this.context === 'repeater' ) {

        val = this.value;
        type = this.type;

      }     

      if ( type === 'percentage' && val !== undefined) {

        val = Number(val);
        val *= 100;
        val = val.toFixed(2);

      } 

      if ( type === 'currency' && val !== undefined) {

        val = Number(val);
        val = val.toFixed(2);

      }

      /**
       * Replacement
       *
       * @since  1.2.5
       * Basically replaces certain tokens with certain values
       */
      
      if ( this.replace ) {

        switch ( this.replace ) {

          /** Replace the %n token with the current user's name */
          case 'name':
            val = val.replace('%n', this.$store.getters.getCurrentClientName());
            break;

        }

      }

  		return val;

  	},

    /**
     * setType()
     * Sets the type for the input. Values include:
     * - text
     * - number
     * - currency
     * - percentage
     */
  	setType() {

      switch (this.type) {

        case 'text':
          return 'text';
          break;

        case 'number':
          return 'number';
          break;

        case 'currency':
          return 'number';
          break;

        case 'percentage':
          return 'number';
          break;

        case 'age':
          return 'number';
          break;

        default:
          return 'text';
      }

  	},

    setDataType() {

      return this.type;

    },

  	setClass() {

      var c = 'input input--text';

      if ( this.type !== undefined ) {

        c = 'input input--' + this.type;

      }

  		return c;

  	},

    setWrapperClass() {

      var type = this.type;

      if ( type !== undefined ) {

        return "input-wrap input-wrap--" + this.type;

      }

      else {

        return "input-wrap";

      }

    },

  	// startValue() {

  	// 	if (this.field) {

	  // 		return this.$store.getters[this.field];

  	// 	}

  	// },

    useLabel() {

      if ( this.label !== undefined ) {

        return true;

      }

      return false;

    }

  },

  props : [

  	'action',
  	'context',

  	// Default props
  	'field',
  	'placeholder',
  	'type',
  	'value',
    'label',
    'id',
    'disabled',
    'setting',
    'replace',

  	// Repeater-specific props
  	// These props are used in repeaters to help map cell inputs
  	// to data in the state.
  	'row',
  	'index',
    'k',
    'modal',

    'data-type',

  ],

  data() {

    return {

    }

  }

}

</script>

<style lang="scss">

	.input-wrap {

		margin: 0 0 .75rem;
    position: relative;

    &::before,
    &::after {

      display: none;
      position: absolute;
      left: 2px;
      bottom: .5rem;
      width: 2rem;
      height: 1.5rem;
      align-items: center;
      justify-content: center;
      color: #777;

      border-right: 1px solid rgba(255, 255, 255, .17);

    }

    &::after {

      left: auto;
      right: 0;

    }

	}

  .input-wrap--currency {

    width: 12rem;

    &::before {

      content: '$';
      display: flex;

    }

    .input {

      padding-left: 2.5rem;

    }

  }

  .input-wrap--percentage {

    max-width: 6rem;

    &::after {

      content: '%';
      display: flex;
      border-right: 0;
      border-left: 1px solid rgba(255, 255, 255, .2);

    }

    .input {

      padding-right: 2.5rem;

    }

  }
	
	.input {

		appearance: none;
		border: 1px solid rgba(0, 0, 0, .04);
		font-size: .8rem;
		padding: .75rem;
    background: rgba(0, 0, 0, .05);
    width: 100%;
    color: #444;
    border-radius: 2px;
    text-align: left;
    box-shadow: 0 0 4px rgba(0, 0, 0, .05);
    outline: none;

    &:focus,
    &:active,
    &.js-active {

      border: 1px solid rgba(255, 255, 255, .3);

    }

    &::-webkit-input-placeholder { /* Chrome/Opera/Safari */
      color: #888;
      opacity: .5;
    }    

	}

  .input--currency {

    text-align: right;

  }

  .input--percentage {

    text-align: right;

  } 

  .input--age {

    width: 5rem;

  } 

  input[type=number]::-webkit-inner-spin-button, 
  input[type=number]::-webkit-outer-spin-button { 
    -webkit-appearance: none; 
    margin: 0; 
  } 
   
</style>


// WEBPACK FOOTER //
// TextInput.vue?6692d856